module.exports = __webpack_public_path__ + "postmates.svg?3a120b7fd8f9005bef9be7fc496eaa11";